export const VALID_US_ZIP_REGEX = /^[0-9]{5}(?:-[0-9]{4})?$/;

const allFormFieldsFilled = (formData: object) => {
  return Object.values(formData).every(value => {
    return value !== "" && value !== null && value !== undefined;
  });
};

const isNameValid = (field: string) => new RegExp(/^[^\s].*/).test(field);

const hasBeginningWhiteSpace = (field: string) => new RegExp(/^\s/g).test(field);

const getFieldErrors = (errors: Record<string, string[]>) => {
  for (const field in errors) {
    if (errors[field] && field !== "__typename") {
      return `${field} ${errors[field][0]}`;
    }
  }

  return null;
};

const hasFieldErrors = (errors: Record<string, string[]>) =>
  Object.values(errors).some(error => error);

const isZipCodeValid = (zipCode: string) => new RegExp(VALID_US_ZIP_REGEX).test(zipCode);

export {
  allFormFieldsFilled,
  getFieldErrors,
  hasBeginningWhiteSpace,
  isNameValid,
  isZipCodeValid,
  hasFieldErrors,
};
